import { defineCustomElement } from '@tyler-components-web/core';
import { OmnibarProfileButtonComponent } from './omnibar-profile-button';
export * from './omnibar-profile-button-adapter';
export * from './omnibar-profile-button-constants';
export * from './omnibar-profile-button-foundation';
export * from './omnibar-profile-button';
export function defineOmnibarProfileButtonComponent() {
    defineCustomElement(OmnibarProfileButtonComponent);
}
